// initial state
const state = {
    sideMenuOpen: true
}

// getters
const getters = {
    
}

// actions
const actions = {
    
}

// mutations
const mutations = {
    // 更改菜单状态
    setSideMenuOpenState(state, open) {
        state.sideMenuOpen = open;
    }
}
  
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js